/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FilesDownloadCombinedPdf/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import HappyPdfIcon from 'DesignSystem/Svgs/HappyPdfIcon/index'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FilesDownloadCombinedPdf({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/FilesDownloadCombinedPdf"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={dtSpaceM}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 size="medium"
>
{childProps => (
<React.Fragment>
<div
  data-testid="FilesDownloadCombinedPdf.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-ZIJys7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-ZIJys7': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Preparing PDF..."
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="FilesDownloadCombinedPdf.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<HappyPdfIcon
  viewPath={`${viewPath}/HappyPdfIcon`}
 width={144}
 height={144}
/>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 marginTop={dtSpaceM}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 size="large"
 text="The PDF will open automatically it's ready for download."
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}